<template>
  <select
    v-show="!loading"
    :id="id"
    :name="name"
    class="s2"
    :disabled="disabled"
    :class="cls"
    :style="css"
    :required="required"
    :multiple="multiple"
  >
    <option
      v-if="placeholder && (!multiple || multiple !== 'multiple')"
    ></option>
    <option v-if="defopt" :value="defopt.val">{{ defopt.text }}</option>
    <template v-for="(v, index) in opts.values">
      <option
        :value="v.val"
        :key="index"
        v-if="opts && (!def || (v.text !== def.text && v.val !== def.val))"
        :selected="isSelected(v.text, v.val)"
      >
        <span v-if="noTruncate">{{ v.text }}</span>
        <span v-else>{{ v.text }}</span>
      </option>
    </template>
  </select>
</template>
<script>
import $ from "jquery";
import api from "../../../services/api";
import store from "@/store.js";
window.jQuery = window.$ = $;
require("select2");

import select2 from "select2"; // eslint-disable-line

export default {
  props: [
    "name",
    "noTruncate",
    "url",
    "options",
    "selected",
    "css",
    "def",
    "value",
    "disabled",
    "multi",
    "placeholder",
    "lazy",
    "allowClear",
    "required",
    "text",
    "destroy",
    "cls",
    "apo",
    "prevent",
    "nullable",
    "id_orig",
    "search",
    "spinner",
  ],
  data() {
    return {
      opts: {
        values: [],
      },
      lastEmitedValue: "",
      validate: this.prevent !== true,
      defopt: this.def,
      lazySelected: {},
      loading: false,
      sel:
        typeof this.selected !== "undefined"
          ? this.selected
          : typeof this.def !== "undefined"
          ? this.def.value
          : null,
      data_url: this.url ? this.url : null,
    };
  },
  computed: {
    id: function () {
      if (typeof this.id_orig !== "undefined") {
        return this.id_orig;
      } else {
        return Math.random().toString(36).substring(7);
      }
    },
    multiple: function () {
      if (this.multi) {
        return "multiple";
      } else {
        return false;
      }
    },
    config: function () {
      let self = this;
      if (this.placeholder) {
        if (self.lazy) {
          // pierwszy if wykorzystywany jest np. w formularzu wniosku, kiedy wypełniamy lazy select danymi z submission
          if (
            !self.selected &&
            typeof self.text !== "undefined" &&
            typeof self.value !== "undefined"
          ) {
            let option = $("<option selected>" + self.text + "</option>").val(
              self.value
            );
            $('select[id="' + self.id + '"] > option').remove();
            $('select[id="' + self.id + '"]')
              .append(option)
              .trigger("change"); // append the option and update Select2
          } else if (self.selected) {
            self.lastEmitedValue = self.selected;
            // nie wiem czy kiedykolwiek tu wchodzimy; do sprawdzenia
            let text = self.selected;
            if (typeof self.text !== "undefined") {
              text = self.text;
            }
            let option;
            if (self.value) {
              option = $("<option selected>" + text + "</option>").val(
                self.value
              );
            } else {
              option = $("<option selected>" + text + "</option>").val(
                self.selected
              );
            }
            $('select[id="' + self.id + '"] > option').remove();
            $('select[id="' + self.id + '"]')
              .append(option)
              .trigger("change"); // append the option and update Select2
          }

          return {
            width: "style",
            allowClear: self.lazy && self.placeholder && self.allowClear,
            minimumResultsForSearch: this.search ? 0 : -1,
            placeholder: this.placeholder ? this.placeholder : "",
            ajax: {
              url: store.state.api.api_url + "/api" + self.data_url,
              dataType: "json",
              quietMillis: 250,
              data: function (params) {
                return {
                  search: params.term,
                };
              },
              processResults: function (data) {
                let items = data;
                for (let i = 0; i < items.length; i++) {
                  items[i].id = items[i].val;
                }
                return {
                  results: data,
                };
              },
              cache: true,
            },
            minimumInputLength: 3,
            language: {
              inputTooShort: function () {
                return "Wpisz co najmniej 3 znaki";
              },
              noResults: function () {
                return "Nie znaleziono";
              },
              loadingMore: function () {
                return "Ładuję....";
              },
              errorLoading: function () {
                return "Wystąpił błąd podczas ładowania";
              },
            },
          };
        } else {
          return {
            width: "style",
            allowClear: self.placeholder && self.allowClear,
            placeholder: this.placeholder ? this.placeholder : "",
            minimumResultsForSearch: this.search ? 0 : -1,
          };
        }
      } else {
        return {
          width: "style",
          allowClear: self.placeholder && self.allowClear,
          minimumResultsForSearch: this.search ? 0 : -1,
        };
      }
    },
  },
  watch: {
    url: function () {
      this.data_url = this.url ? this.url : null;
    },
    options: function (val1, val2) {
      let diff = 0;

      if (
        typeof val1 !== typeof val2 ||
        typeof val1.values !== typeof val2.values ||
        val1.values.length !== val2.values.length
      ) {
        diff++;
      } else if (
        val1.def &&
        val2.def &&
        (val1.def.val !== val2.def.val || val1.def.text !== val2.def.text)
      ) {
        diff++;
      } else {
        for (let i = 0; i < val1.values.length; i++) {
          if (
            val1.values[i].text !== val2.values[i].text ||
            val1.values[i].val !== val2.values[i].val
          ) {
            diff++;
          }
        }
      }
      if (diff > 0) {
        this.updateSelect();
      }
    },
    "options.values": function (val1, val2) {
      let diff = 0;

      if (typeof val1 !== typeof val2 || val1.length !== val2.length) {
        diff++;
      } else {
        for (let i = 0; i < val1.length; i++) {
          if (val1[i].text !== val2[i].text || val1[i].val !== val2[i].val) {
            diff++;
          }
        }
      }
      if (diff > 0) {
        this.updateSelect();
      }
    },
    selected: function () {
      this.sel = this.selected;
      if (this.lazy) {
        let $option = $("<option selected>" + this.selected + "</option>").val(
          this.selected
        );
        $('select[id="' + this.id + '"] > option').remove();
        $('select[id="' + this.id + '"]')
          .append($option)
          .trigger("change"); // append the option and update Select2
      }
      this.updateSelect();
    },
  },
  methods: {
    clear: function () {
      this.sel = null;
      this.lastEmitedValue = null;
      if (typeof this.destroy !== "undefined" && this.destroy) {
        return;
      }
      if (this.multiple === "multiple") {
        $('select[id="' + this.id + '"]')
          .val([])
          .select2();
      } else {
        // this.sel = ''
        // $('select[id="' + this.id + '"]').val(null).select2()
        $('select[id="' + this.id + '"]')
          .val(null)
          .trigger("change");
        //                    $('#' + this.id).select2('data', null);
        //                    if(typeof $('#' + this.id).select2('data')[0] !== 'undefined')
        //                        $('#' + this.id).select2('data')[0].text = '';
      }
    },
    changeUrl: function (url) {
      this.data_url = url;
      this.updateSelect();
    },
    getValues: function (val) {
      if (typeof val !== "undefined") {
        for (let i = 0; i < this.opts.values.length; i++) {
          if (val === this.opts.values[i].val) {
            return this.opts.values[i];
          }
        }
      }
      return this.opts.values;
    },
    isSelected: function (text, val) {
      let test;
      let s1 = text;
      let s2 = val;
      if (
        typeof this.selected !== "undefined" &&
        this.multi &&
        Array.isArray(this.selected)
      ) {
        for (let i = 0; i < this.selected.length; i++) {
          if (
            this.selected[i].uid === s1 ||
            this.selected[i].uid === s2 ||
            this.selected[i].name === s1 ||
            this.selected[i].name === s2
          ) {
            return true;
          }
        }
      }

      if (
        this.selected &&
        (s2 === this.selected ||
          (Array.isArray(this.selected) && $.inArray(s2, this.selected) >= 0))
      ) {
        return "selected";
      } else if (
        this.selected &&
        (s1 === this.selected ||
          (Array.isArray(this.selected) && $.inArray(s1, this.selected) >= 0))
      ) {
        return "selected";
      } else if (
        this.sel &&
        (s2 === this.sel ||
          (Array.isArray(this.sel) && $.inArray(s2, this.sel) >= 0))
      ) {
        return "selected";
      } else if (
        this.sel &&
        (s1 === this.sel ||
          (Array.isArray(this.sel) && $.inArray(s1, this.sel) >= 0))
      ) {
        return "selected";
      }
      s1 = text.toString();
      s2 = val.toString();

      if (typeof this.selected !== "undefined" && this.selected) {
        if (
          this.selected.toString() &&
          (s2 === this.selected.toString() ||
            (Array.isArray(this.selected.toString()) &&
              $.inArray(s2, this.selected.toString()) >= 0))
        ) {
          return "selected";
        } else if (
          this.selected.toString() &&
          (s1 === this.selected.toString() ||
            (Array.isArray(this.selected.toString()) &&
              $.inArray(s1, this.selected.toString()) >= 0))
        ) {
          return "selected";
        } else if (
          this.sel &&
          (s2 === this.sel ||
            (Array.isArray(this.sel) && $.inArray(s2, this.sel) >= 0))
        ) {
          return "selected";
        } else if (
          this.sel &&
          (s1 === this.sel ||
            (Array.isArray(this.sel) && $.inArray(s1, this.sel) >= 0))
        ) {
          return "selected";
        }
      }
      return test;
    },
    updateSelect: function () {
      let self = this;
      // 'opts' aktualizujemy na podstawie propsa 'options' tylko wtedy, kiedy nie ma propsa 'url'
      if (
        typeof this.options !== "undefined" &&
        (typeof this.data_url === "undefined" || !this.data_url)
      ) {
        this.opts = this.options;
        if (typeof this.options.def !== "undefined") {
          this.defopt = this.options.def;
        }
      }

      window.Vue.nextTick(function () {
        // aktualizacja selecta m.in. po zmianie 'option.values'

        if (typeof self.destroy !== "undefined" && self.destroy) {
          return;
        }

        try {
          $('select[id="' + self.id + '"]')
            .select2(self.config)
            .off("change");
          $('select[id="' + self.id + '"]')
            .select2(self.config)
            .on("change", function () {
              if (
                $("#" + this.id).closest("form").length > 0 &&
                self.validate
              ) {
                $(this).valid();
              }
              if (
                self.nullable ||
                String($(this).val()).length > 0 ||
                (self.sel !== "null" && self.sel != null)
              ) {
                let vvval = null;
                let lev = null;
                if (self.multi) {
                  vvval = JSON.stringify($(this).val());
                  lev = JSON.stringify(self.lastEmitedValue);
                } else {
                  vvval = $(this).val();
                  lev = self.lastEmitedValue;
                }
                if (vvval !== lev) {
                  self.lastEmitedValue = $(this).val();
                  self.$emit("changed", {
                    name: self.name,
                    value: $(this).val(),
                    sel: false,
                    text:
                      typeof $(this).select2("data")[0] !== "undefined"
                        ? $(this).select2("data")[0].text
                        : "",
                  });
                  self.$emit("input", $(this).val());
                } else {
                  self.$emit("input", $(this).val());
                }
              } else {
                // if (self.name === 'product_uid') {
                //   console.log('emit dla product_uid: ' + e.target.value)
                // }
                // zakomentowałem, ale nie wiem czy coś się nie wysypało
                // self.sel = e.target.value
                // self.$emit('input', e.target.value)
              }
            });
        } catch (e) {
          console.log(e);
        }
      });
    },
  },
  updated() {
    $('select[id="' + this.id + '"]').change();
  },
  mounted() {
    if (typeof this.url !== "undefined" && typeof this.lazy === "undefined") {
      this.loading = true;
    }
    if (typeof this.api === "undefined") {
      this.api = false;
    }

    if (this.sel) {
      this.$emit("changed", { name: this.name, value: this.sel, sel: true });
    }

    let self = this;
    if (
      !self.lazy &&
      this.data_url &&
      typeof this.data_url !== "undefined" &&
      this.data_url.length > 0
    ) {
      api.get(this.data_url, [], function (response) {
        self.opts.values = response;
        self.updateSelect();
        self.loading = false;
        // this.$emit('loaded', {});
      });
    } else {
      self.updateSelect();
    }
  },
};
</script>
